export const paths = {
    home: {path: '/home', name: 'Home'},
    about: {path: '/about', name: 'About'},
    resume: {path: '/resume', name: 'Resume'},
    // projects: {path: '/projects', name: 'Projects'},
}